export const supportConstants = {
    REQUEST: 'SUPPORT_REQUEST',
    RESET: 'SUPPORT_RESET',
    RESET_STATUS: 'SUPPORT_RESET_STATUS',
    SUCCESS: 'SUPPORT_SUCCESS',
    FAILURE: 'SUPPORT_FAILURE',
    CHANGE_VALUE: 'SUPPORT_CHANGE_VALUE',
}

export const categoriesConstants = {
    REQUEST: 'CATEGORIES_REQUEST',
    SUCCESS: 'CATEGORIES_SUCCESS',
    FAILURE: 'CATEGORIES_FAILURE',
}
export const getNewsConstants = {
    REQUEST: 'GET_NEWS_REQUEST',
    SUCCESS: 'GET_NEWS_SUCCESS',
    FAILURE: 'GET_NEWS_FAILURE',
}

export const catalogSearchConstants = {
    CHANGE: 'CATALOG_SEARCH_PARAMS_CHANGE',
    RESET: 'CATALOG_SEARCH_PARAMS_RESET',
}

export const catalogInlineSearchConstants = {
    CHANGE: 'CATALOG_INLINE_SEARCH_PARAMS_CHANGE',
    RESET: 'CATALOG_INLINE_SEARCH_PARAMS_RESET',
}

export const postRequestAPIConstants = {
    REQUEST: 'INTENTO_API_REQUEST_REQUEST',
    SUCCESS: 'INTENTO_API_REQUEST_SUCCESS',
    FAILURE: 'INTENTO_API_REQUEST_FAILURE',
    RESET: 'INTENTO_API_REQUEST_RESET',
}

export const apidocsFromElasticConstants = {
    REQUEST: 'PROVIDERS_DATA_REQUEST',
    SUCCESS: 'PROVIDERS_DATA_SUCCESS',
    FAILURE: 'PROVIDERS_DATA_FAILURE',
}

export const providersFromAPIConstants = {
    REQUEST: 'GET_PROVIDERS_REQUEST',
    SUCCESS: 'GET_PROVIDERS_SUCCESS',
    FAILURE: 'GET_PROVIDERS_FAILURE',
}

export const getIntentProvidersConstants = {
    REQUEST: 'GET_INTENT_PROVIDERS_REQUEST',
    SUCCESS: 'GET_INTENT_PROVIDERS_SUCCESS',
    FAILURE: 'GET_INTENT_PROVIDERS_FAILURE',
}

export const getIntentLanguagesConstants = {
    REQUEST: 'GET_INTENT_LANGUAGES_REQUEST',
    SUCCESS: 'GET_INTENT_LANGUAGES_SUCCESS',
    FAILURE: 'GET_INTENT_LANGUAGES_FAILURE',
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/constants/index.js